import React from 'react';

import { fg } from '@confluence/feature-gating';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint, LoadablePaint } from '@confluence/loadable';

import type { ComponentProps as MainButtonsProps } from './MainButtons.tsx';

const MainButtonsLoader: LoadableType<MainButtonsProps> = LoadableAfterPaint({
	loader: async () => {
		return (await import(/* webpackChunkName: "loadable-MainButtons" */ './MainButtons.tsx'))
			.MainButtons;
	},
});

const MainButtonsSSRLoader = LoadablePaint({
	loader: async () => {
		return (await import(/* webpackChunkName: "loadable-MainButtons" */ './MainButtons.tsx'))
			.MainButtons;
	},
});

export const MainButtons = (props: MainButtonsProps): React.JSX.Element => (
	<>
		{/* oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates */}
		{fg('confluence_frontend_usd_ssr') ? (
			<MainButtonsSSRLoader {...props} />
		) : (
			<MainButtonsLoader {...props} />
		)}
	</>
);

type LoadMainButtonsResult = Awaited<ReturnType<typeof MainButtonsLoader.preload>>;

export const loadMainButtons = async (): Promise<void | LoadMainButtonsResult> =>
	MainButtonsLoader.preload();
